<div class="mb-4 mt-4 flex items-center justify-between">
  <div class="flex items-center">
    <bl-frontend-button
      density="slim"
      variant="tonal"
      [trailingIcon]="{ name: 'sync' }"
      [disabled]="!client || !currentFolder"
      (onclick)="refresh()">
    </bl-frontend-button>
    <span class="mx-2"><label class="font-bold mb-0">Sökväg:</label> {{ currentVisualPath }}</span>
    <bl-frontend-button
      *ngIf="currentFolder"
      density="slim"
      variant="tonal"
      [trailingIcon]="{ name: 'arrow-up' }"
      (onclick)="upDir()">
    </bl-frontend-button>
  </div>
  <bl-frontend-button
    *ngIf="canShareDocuments"
    variant="primary"
    text="Dela dokument"
    (onclick)="triggerShareDocuments()">
  </bl-frontend-button>
</div>

<p-table *ngIf="!currentFolder" [value]="folders" [tableStyle]="{ 'table-layout': 'fixed' }">
  <ng-template pTemplate="header">
    <tr>
      <th class="font-normal truncate">Filnamn</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr (click)="openFolder(rowData)" style="cursor: pointer">
      <td>
        <i [class]="rowData.icon" style="color: #2f6fed"></i>
        <span class="ml-2">{{ rowData.name }}</span>
      </td>
    </tr>
  </ng-template>
</p-table>

<ng-container *ngIf="currentFolder">
  <input
    type="file"
    #shareFileInput
    multiple="multiple"
    accept="*/*"
    style="display: none"
    (change)="onShareFilesSelected($event)" />

  <div class="mb-3 flex items-center rounded bg-bl-grey-100 px-3 py-2">
    <bl-frontend-icon name="search" size="sm"></bl-frontend-icon>
    <input
      type="text"
      class="ml-2 w-full border-0 bg-transparent focus:outline-none"
      placeholder="Sök"
      [(ngModel)]="searchQuery" />
  </div>

  <div
    class="table-closed-paginator rounded transition-colors"
    [class.outline]="isDragOver"
    [class.outline-2]="isDragOver"
    [class.outline-dashed]="isDragOver"
    [class.outline-bl-blue-500]="isDragOver"
    [class.bg-bl-blue-50]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)">
    <p-table
      [value]="rows"
      [columns]="documentColumns"
      [paginator]="true"
      [rows]="10"
      [tableStyle]="{ 'table-layout': 'fixed' }">
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            <div class="my-5 text-center">
              <ng-container *ngIf="loading; else emptyText">Laddar listan, vänligen vänta...</ng-container>
              <ng-template #emptyText>
                {{ canShareDocuments ? 'Inga dokument ännu. Dra och släpp filer här för att dela dem.' : 'Inga dokument ännu.' }}
              </ng-template>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th class="truncate text-xs uppercase tracking-wide text-description">Filnamn</th>
          <th class="truncate text-xs uppercase tracking-wide text-description" style="flex: 0 0 140px; width: 140px">
            Delad
          </th>
          <th class="truncate text-xs uppercase tracking-wide text-description" style="flex: 0 0 140px; width: 140px">
            Status
          </th>
          <th class="truncate" style="flex: 0 0 80px; width: 80px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr *ngIf="isFolderRow(rowData)" (click)="openSubfolder(rowData.folderName)" style="cursor: pointer">
          <td>
            <div class="flex items-center gap-2">
              <i class="fa fa-folder" style="color: #f5b301"></i>
              <span class="min-w-0 flex-1 truncate">{{ rowData.folderName }}</span>
              <span *ngIf="rowData.deletable" (click)="$event.stopPropagation()">
                <bl-frontend-meatballmenu [items]="folderMenuItemsFor(rowData)"></bl-frontend-meatballmenu>
              </span>
            </div>
          </td>
          <td style="flex: 0 0 140px; width: 140px"></td>
          <td style="flex: 0 0 140px; width: 140px"></td>
          <td style="flex: 0 0 80px; width: 80px"></td>
        </tr>
        <tr *ngIf="!isFolderRow(rowData)" class="group">
          <td>
            <div class="flex items-center gap-2">
              <i class="far fa-file" style="color: #2f6fed"></i>
              <span class="min-w-0 flex-1 truncate">
                {{ rowData.fileName }}
                <span *ngIf="currentFolder?.key !== 'outgoing' && rowData.path" class="ml-2 text-xs text-description">({{ rowData.path }})</span>
              </span>
              <bl-frontend-iconbutton
                *ngIf="canManageAccess(rowData)"
                class="invisible group-hover:visible"
                name="user-plus"
                title="Hantera åtkomst"
                (click)="manageAccess(rowData)">
              </bl-frontend-iconbutton>
            </div>
          </td>
          <td style="flex: 0 0 140px; width: 140px">{{ rowData.sharedAt | date: 'yyyy-MM-dd' }}</td>
          <td style="flex: 0 0 140px; width: 140px">
            <bl-frontend-badge [text]="statusBadge(rowData).text" [variant]="statusBadge(rowData).variant"></bl-frontend-badge>
          </td>
          <td style="flex: 0 0 80px; width: 80px">
            <bl-frontend-meatballmenu [items]="menuItemsFor(rowData)"></bl-frontend-meatballmenu>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <table *ngIf="canShareDocuments" class="mt-4">
    <tr>
      <td>
        <input
          type="text"
          class="form-control input-sm"
          [(ngModel)]="newFolderName"
          placeholder="Ange nytt mappnamn" />
      </td>
      <td style="padding-left: 10px">
        <bl-frontend-button variant="secondary" [disabled]="!newFolderName" (onclick)="createFolder()" text="Skapa mapp">
        </bl-frontend-button>
      </td>
    </tr>
  </table>
</ng-container>

<app-lundify-share-dialog
  [client]="client"
  [file]="fileToShare"
  [path]="sharePath"
  [sharedDocument]="documentToManage"
  [visible]="shareDialogVisible"
  (visibleChange)="onShareDialogVisibleChange($event)"
  (shared)="onDocumentShared()">
</app-lundify-share-dialog>
